import { useIsomorphicLayoutEffect } from '@react-hookz/web';
import { useState } from 'react';
export const useAdup = () => {
  const [adup, setAdup] = useState(window === undefined ? null : window.uAd);
  useIsomorphicLayoutEffect(() => {
    if (window !== undefined && !adup) {
      if (typeof window.uAd_init === 'function') {
        window.uAd_init.callbacks.push(setAdup);
      } else {
        const init = () => {
          for (const callback of init.callbacks) {
            callback(window.uAd);
          }
          delete window.uAd_init;
        };
        init.callbacks = [setAdup];
        window.uAd_init = init;
        // load script
        const g = document.createElement('script');
        const s = document.getElementsByTagName('script')[0];
        g.src = 'https://s.d.adup-tech.com/jsapi';
        g.async = true;
        s.parentNode?.insertBefore(g, s);
      }
    }
    return () => {
      if (window !== undefined && window.uAd_init) {
        window.uAd_init.callbacks = window.uAd_init.callbacks.filter(callback => callback !== setAdup);
      }
    };
  }, [adup]);
  return adup;
};